export enum UviEventConsumptionType {
  HOT_WATER = 'HOT_WATER',
  HEATING = 'HEATING'
}
